import {ColumnState} from 'ag-grid-community';

import {filter, map, pick} from 'ramda';

export const extractColumnStateProperties = (columnState: ColumnState[]) =>
  filter(
    (column: Pick<ColumnState, 'colId'>) => column.colId !== 'eag-col-actions',
    map(pick(['colId', 'width', 'hide', 'pinned']), columnState as Required<ColumnState>[])
  );
